module.exports = __webpack_public_path__ + "static/media/CeraPro-Regular.bd818dce.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/CeraPro-Regular.woff2
// module id = 167
// module chunks = 56